import { OrderedMap } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import {
  GET_TASKS,
  GET_TASK,
  CREATE_FROM_TODAY,
  ADD_TASK,
  DELETE_TASK,
} from './actions'

export const INITIAL_STATE = new OrderedMap()

export const taskSchema = new schema.Entity('task', {}, { idAttribute: '_id' })

export const log = createReducer(INITIAL_STATE, {
  [GET_TASKS.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [taskSchema]).entities.task),

  [GET_TASK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, taskSchema).entities.task),

  [ADD_TASK.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [taskSchema]).entities.task),

  [CREATE_FROM_TODAY.FULFILLED]: (state, { payload }) =>
    state.mergeDeep(normalize(payload, [taskSchema]).entities.task),

  [DELETE_TASK.FULFILLED]: (state, { payload }) => state.delete(payload),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/log/reducers.js